<template>
    <div class="mx-auto max-w-[500px]">
        <login-modal :org-level="true" />
    </div>
</template>

<script setup lang="ts">
import LoginModal from '~/components/Verification/LoginModal.vue'
import {
    definePageMeta,
    useLayoutMode,
    useRouteLink,
    useViewer
} from '#imports'
import { useRoute } from '#app'
import { useRouter } from 'vue-router'
import { watchEffect } from 'vue'

definePageMeta({
    layout: 'org'
})

const route = useRoute()
const router = useRouter()
const { preserveModeLink } = useLayoutMode()
const { profileLink } = useRouteLink()
const viewer = useViewer()

watchEffect(() => {
    if (viewer.value !== undefined) {
        if (
            typeof route.query.redirect === 'string' &&
            route.query.redirect.length > 0
        ) {
            router.push(
                preserveModeLink(decodeURIComponent(route.query.redirect))
            )
        } else {
            router.replace(profileLink())
        }
    }
})
</script>
